
import { filterMatchesByOddsRange } from './helpers';

/**
 * Calculate profit/loss for Over 2.5 goals bets
 */
export const calculateOver25ProfitForRange = (
  matches: any[], 
  range: { min: number, max: number }, 
  oddsType: 'home' | 'away'
): number => {
  const matchesInRange = filterMatchesByOddsRange(matches, range, oddsType);
  
  let profitLoss = 0;
  
  matchesInRange.forEach(match => {
    // Get the over 2.5 goals odds (B365>2.5)
    const over25Odds = typeof match['B365>2.5'] === 'string' 
      ? parseFloat(match['B365>2.5']) 
      : match['B365>2.5'];
      
    if (!isNaN(over25Odds)) {
      // Calculate total goals in the match
      const homeGoals = typeof match.FTHG === 'string' ? parseInt(match.FTHG) : match.FTHG || 0;
      const awayGoals = typeof match.FTAG === 'string' ? parseInt(match.FTAG) : match.FTAG || 0;
      const totalGoals = homeGoals + awayGoals;
      
      if (totalGoals > 2.5) {
        // Over 2.5 bet won
        profitLoss += (over25Odds - 1);
      } else {
        // Over 2.5 bet lost
        profitLoss -= 1;
      }
    }
  });
  
  return profitLoss;
};

/**
 * Calculate profit/loss for Under 2.5 goals bets
 */
export const calculateUnder25ProfitForRange = (
  matches: any[], 
  range: { min: number, max: number }, 
  oddsType: 'home' | 'away'
): number => {
  const matchesInRange = filterMatchesByOddsRange(matches, range, oddsType);
  
  let profitLoss = 0;
  
  matchesInRange.forEach(match => {
    // Get the under 2.5 goals odds (B365<2.5)
    const under25Odds = typeof match['B365<2.5'] === 'string' 
      ? parseFloat(match['B365<2.5']) 
      : match['B365<2.5'];
      
    if (!isNaN(under25Odds)) {
      // Calculate total goals in the match
      const homeGoals = typeof match.FTHG === 'string' ? parseInt(match.FTHG) : match.FTHG || 0;
      const awayGoals = typeof match.FTAG === 'string' ? parseInt(match.FTAG) : match.FTAG || 0;
      const totalGoals = homeGoals + awayGoals;
      
      if (totalGoals < 2.5) {
        // Under 2.5 bet won
        profitLoss += (under25Odds - 1);
      } else {
        // Under 2.5 bet lost
        profitLoss -= 1;
      }
    }
  });
  
  return profitLoss;
};

/**
 * Get breakdown of over/under 2.5 goals profit/loss
 */
export const getOverUnderProfitBreakdown = (
  range: { min: number, max: number }, 
  oddsType: 'home' | 'away',
  matchesParam?: any[]
): { over: { wins: number, losses: number }, under: { wins: number, losses: number } } => {
  const matches = matchesParam || [];
  const matchesInRange = filterMatchesByOddsRange(matches, range, oddsType);
  
  let overWins = 0;
  let overLosses = 0;
  let underWins = 0;
  let underLosses = 0;
  
  matchesInRange.forEach(match => {
    const over25Odds = typeof match['B365>2.5'] === 'string' ? parseFloat(match['B365>2.5']) : match['B365>2.5'];
    const under25Odds = typeof match['B365<2.5'] === 'string' ? parseFloat(match['B365<2.5']) : match['B365<2.5'];
    
    const homeGoals = typeof match.FTHG === 'string' ? parseInt(match.FTHG) : match.FTHG || 0;
    const awayGoals = typeof match.FTAG === 'string' ? parseInt(match.FTAG) : match.FTAG || 0;
    const totalGoals = homeGoals + awayGoals;
    
    if (!isNaN(over25Odds)) {
      if (totalGoals > 2.5) {
        // Over 2.5 bet won
        overWins += (over25Odds - 1);
      } else {
        // Over 2.5 bet lost
        overLosses += 1;
      }
    }
    
    if (!isNaN(under25Odds)) {
      if (totalGoals < 2.5) {
        // Under 2.5 bet won
        underWins += (under25Odds - 1);
      } else {
        // Under 2.5 bet lost
        underLosses += 1;
      }
    }
  });
  
  return {
    over: { wins: overWins, losses: overLosses },
    under: { wins: underWins, losses: underLosses }
  };
};
